import React, { useState, useEffect } from 'react';
import { Button, Col, Form, FormGroup, Label, UncontrolledTooltip } from 'reactstrap';
import { Field, reduxForm, change } from 'redux-form';
import ValidatedSelect from "../../../components/ValidatedSelect";
import ValidatedInput from "../../../components/ValidatedInput";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { formatAmount, normalizeAmount, getSourceOfFunds } from "../../../utils/helper";

const AccountOwnerFinancialInfo = ({ nextStep, prevStep, handleSubmit, active, processing, secondary, investAccount, dispatch }) => {
    const [sourceOfFunds] = useState(getSourceOfFunds());

    useEffect(() => {
        if (active && investAccount && investAccount.id) {
            if (secondary) {
                dispatch(change('AccountOwnerFinancialInfoForm', 'annual_salary', investAccount.secondary_account_owner_annual_salary || null));
                dispatch(change('AccountOwnerFinancialInfoForm', 'net_worth', investAccount.secondary_account_owner_net_worth || null));
                dispatch(change('AccountOwnerFinancialInfoForm', 'source_of_funds', investAccount.secondary_account_owner_source_of_funds || null));
            } else {
                dispatch(change('AccountOwnerFinancialInfoForm', 'annual_salary', investAccount.primary_account_owner_annual_salary || null));
                dispatch(change('AccountOwnerFinancialInfoForm', 'net_worth', investAccount.primary_account_owner_net_worth || null));
                dispatch(change('AccountOwnerFinancialInfoForm', 'source_of_funds', investAccount.primary_account_owner_source_of_funds || null));
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [active, investAccount]);

    const handleNext = (formData) => {
        let payload = {};
        if (secondary) {
            payload.secondary_account_owner_annual_salary = +formData.annual_salary;
            payload.secondary_account_owner_net_worth = +formData.net_worth;
            payload.secondary_account_owner_source_of_funds = formData.source_of_funds;
        } else {
            payload.primary_account_owner_annual_salary = +formData.annual_salary;
            payload.primary_account_owner_net_worth = +formData.net_worth;
            payload.primary_account_owner_source_of_funds = formData.source_of_funds;
        }
        nextStep(payload);
    }

    const handleBack = () => {
        prevStep();
    }

    return (
        <div className={`account-setup-wrapper ${!active ? 'd-none' : ''}`}>
            <Form className="form-container" onSubmit={handleSubmit(handleNext)}>
                <div className="back-btn">
                    <Button color="link" onClick={handleBack}>back</Button>
                </div>
                <div className="form-header mt-md-3 mt-0">
                    <h2>{secondary ? 'SECONDARY' : 'PRIMARY'} ACCOUNT OWNER</h2>
                    <span>Please tell us a little about your financial situation</span>
                </div>
                <div className="account-info-container">
                    <FormGroup row>
                        <Label sm={4} >Annual Salary (You)</Label>
                        <Col sm={7}>
                            <Field
                                component={ValidatedInput}
                                type="text"
                                format={formatAmount}
                                normalize={normalizeAmount}
                                prefix="$"
                                name="annual_salary"
                                placeholder="Annual Salary" />
                        </Col>
                        <div sm={1} xs={2}>
                            <span id="annual-salary-tooltip">
                                <FontAwesomeIcon icon={faQuestionCircle} />
                            </span>
                            <UncontrolledTooltip innerClassName="text-left fs12" placement="right" target="annual-salary-tooltip">
                                This is your individual Annual Income, not your Household Annual Income.<br /><br />
                                Note: This is required by the regulators.
                            </UncontrolledTooltip>
                        </div>
                    </FormGroup>
                    <FormGroup row>
                        <Label sm={4}>Net Worth (You)</Label>
                        <Col sm={7}>
                            <Field
                                component={ValidatedInput}
                                type="text"
                                format={formatAmount}
                                normalize={normalizeAmount}
                                prefix="$"
                                name="net_worth"
                                placeholder="Net Worth" />
                        </Col>
                        <div sm={1} xs={2}>
                            <span id="net-worth-tooltip">
                                <FontAwesomeIcon icon={faQuestionCircle} />
                            </span>
                            <UncontrolledTooltip innerClassName="text-left fs12" placement="right" target="net-worth-tooltip">
                                This is your individual Net Worth, not your Household Net Worth. For Joint Accounts (e.g. Joint Brokerage, Joint Savings)
                                that are equally owned, please use 50% ownership in calculating your individual Net Worth.<br /><br />
                                Note: This is required by the regulators.
                            </UncontrolledTooltip>
                        </div>
                    </FormGroup>
                    <div className="tag_wrap">
                        <span className='pl-3 excl-text' >excl. primary residence</span>
                    </div>
                    <FormGroup row>
                        <Label sm={4}>Source of Funds</Label>
                        <Col sm={7}>
                            <Field
                                component={ValidatedSelect}
                                options={sourceOfFunds}
                                isSearchable={true}
                                isClearable={true}
                                name="source_of_funds"
                                placeholder="Select Source of Funds" />
                        </Col>
                    </FormGroup>
                </div>
                <div className="button_wrapper">
                    <button className="custom-btn-primary" type="submit" disabled={processing}>
                        NEXT STEP {processing && <FontAwesomeIcon icon={faSpinner} spin />}
                    </button>
                </div>
            </Form>
        </div>
    )
};

const validate = (values) => {
    const errors = {};
    if (!values.annual_salary) {
        errors.annual_salary = 'Field is required';
    }
    if (!values.net_worth) {
        errors.net_worth = 'Field is required';
    }
    if (!values.source_of_funds) {
        errors.source_of_funds = 'Field is required';
    }
    return errors;
};

export default reduxForm({
    form: 'AccountOwnerFinancialInfoForm',
    validate,
})(AccountOwnerFinancialInfo);
